<nav
  class="navbar navbar-expand-lg navbar-light border-bottom bg-gradient topbarnav shadow mb-1 sticky-navbar w-100 p-0 fixed-header text-icon fixed-top home-nav-primary-border">
  <div class="container-fluid d-flex justify-content-between ">
    <!-- Left Section: Sidebar Toggle, Logo -->
    <div class="d-flex align-items-center">
      <!-- Logo -->
      <a
        v-if="vettedsa_domain"
        class="navbar-brand fs-4 fw-bolder text-black d-none d-md-flex flex-column align-items-center vettedsa-navbar-brand"
        href="/home"
      >
        <img :src="$clientLogo" alt="Vetted SA Logo" class="logo object-fit-contain pointer">
        <span class="small mb-0 logo-title">Vetted SA</span>
        <p class="logo-subtitle mb-0 fst-italic">Trust Local. Shop Smarter.</p>
      </a>
      <a v-else class="d-flex align-items-center d-none d-md-flex pointer" href="/home">
        <img :src="$clientLogo" class="img-fluid logo pointer" alt="Logo" />
      </a>
 
  <!-- Mobile Logo -->
      <a
        v-if="vettedsa_domain"
        class="navbar-brand fs-4 fw-bolder text-black d-flex d-md-none flex-column align-items-center flex-shrink-0 vettedsa-navbar-brand vettedsa-navbar-brand-mobile"
        :class="{ 'd-none': showSearch }"
        href="/home"
      >
        <img :src="$clientLogo" alt="Vetted SA Logo" class="mobile-logo object-fit-contain pointer">
        <span class="small mb-0 logo-title">Vetted SA</span>
        <p class="logo-subtitle mb-0 fst-italic">Trust Local. Shop Smarter.</p>
      </a>
      <a v-else class="d-flex align-items-center d-flex d-md-none flex-shrink-0" :class="{ 'd-none': showSearch }" href="/home">
        <img :src="$clientLogo" class="img-fluid mobile-logo" alt="Logo" />
      </a>
    </div>
 
    <!-- Center Section: Search Bar (Desktop) -->
        <div class=" d-none d-lg-flex flex-grow-1 justify-content-center position-relative">
  <input v-if="token_exists" v-model="searchQuery" type="text"
         class="form-control text-xxs search-input  rounded-pill p-2 shadow" placeholder="Search..." @click="show_recent" @keydown.enter.prevent="go_to_unified_search" />
 
    <div v-if="searchQuery && filteredProfiles" class="mt-5 position-absolute w-100 search-bar">
      <div class="d-flex justify-content-between align-items-center bg-white border-bottom px-3 py-2 rounded-top">
        <small class="text-muted fw-bold">Search</small>
        <button
          type="button"
          class="btn btn-sm border-0 d-flex align-items-center justify-content-center"
          aria-label="Close search results"
          @click.stop="clear_search_dropdown"
        >
          <i class="bi bi-x-lg home-nav-search-x"></i>
        </button>
      </div>
      <ul v-if="!isLoading || (searchQuery)"
        class="list-group scroll-container h-50 border-0 rounded-bottom text-xxs">

          <!-- Recent Searches -->
          <li v-if="filteredRecent.length" class="list-group-item bg-light">
            <small class="text-muted fw-bold">Recent Searches</small>
          </li>
          <li
            v-if="filteredRecent.length > 0"
            v-for="history in filteredRecent"
            :key="`history-${history.id}`"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center gap-2">
              <i class="ms-3 bx bx-history text-secondary fs-3"></i>
              <a @click="applyHistory(history.query)" class="text-decoration-none text-dark">
                {{ history.query }}
              </a>
            </div>
            <button
              class="btn btn-sm btn-light text-danger border-0"
              @click.stop="removeHistory(history.id)"
            >
              <i class="bx bx-x"></i>
            </button>
          </li>
 
          <!-- People Header -->
          <li v-if="filteredProfiles.profiles?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">People</small>
              <small
                v-if="filteredProfiles.profiles.length > 3"
                class="text-primary pointer"
                @click="toggleExpand('people')"
              >
                {{ expandedSection === 'people' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- People -->
          <li
            v-for="profile in visibleProfiles"
            :key="`profile-${profile.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bxs-user-circle text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_profile(profile)" class="text-decoration-none text-dark">
                  {{ profile.user.first_name }} {{ profile.user.last_name }}
                </a>
                <small class="text-muted">{{ profile?.user.email || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Companies Header -->
          <li v-if="filteredProfiles.companies?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Companies</small>
              <small
                v-if="filteredProfiles.companies.length > 3"
                class="text-primary pointer"
                @click="toggleExpand('companies')"
              >
                {{ expandedSection === 'companies' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Companies -->
          <li
            v-for="company in visibleCompanies"
            :key="`company-${company.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bxs-briefcase text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_profile(company)" class="text-decoration-none text-dark">
                  {{ company.company_name }}
                </a>
                <small class="text-muted">{{ company?.location || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Portals Header -->
          <li v-if="filteredProfiles.portals?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Portals</small>
              <small
                v-if="filteredProfiles.portals.length > 3"
                class="text-primary pointer"
                @click="toggleExpand('portals')"
              >
                {{ expandedSection === 'portals' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Portals -->
          <li
            v-for="portal in visiblePortals"
            :key="`portal-${portal.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bx-globe text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a @click="view_portal(portal)" class="text-decoration-none text-dark">
                  {{ portal.portal_name || portal.name }}
                </a>
                <small class="text-muted">{{ portal?.description || '' }}</small>
              </div>
            </div>
          </li>
 
          <!-- Reports Header -->
          <li v-if="filteredProfiles.reports?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Reports</small>
              <small
                v-if="filteredProfiles.reports.length > 3"
                class="text-primary pointer"
                @click="toggleExpand('reports')"
              >
                {{ expandedSection === 'reports' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Reports -->
          <li
            v-for="report in visibleReports"
            :key="`report-${report.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3" @click="view_report(report)">
              <i class="bx bx-file text-secondary fs-2"></i>
              <div class="d-flex flex-column">
                <a  class="text-decoration-none text-dark">
                  <span v-html="displayedDescription(report)"></span>
                </a>
                <small class="text-muted mt-2">
                  Tags:
                  <span>
                    {{ displayTags(report.tags).join(', ') }}
                    <span v-if="!searchQuery && report.tags.length > 2">...</span>
                  </span>
                </small>
              </div>
            </div>
          </li>

          <li v-if="filteredProfiles.products?.length" class="list-group-item bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted fw-bold">Products</small>
              <small
                v-if="filteredProfiles.products.length > 3"
                class="text-primary pointer"
                @click="toggleExpand('products')"
              >
                {{ expandedSection === 'products' ? 'View Less' : 'View More' }}
              </small>
            </div>
          </li>
          <!-- Products -->
          <li
            v-for="product in visible_products"
            :key="`product-${product.id}`"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3 pointer" @click="view_product_details(product)">
              <img
                :src="product.images?.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
                :alt="product.name || 'Product image'"
                class="profile-image rounded profile-list-avatar object-fit-cover flex-shrink-0 mt-2"
              >
              <div class="d-flex flex-column">
                <a class="text-decoration-none text-dark">
                  <!-- Ensure you use the correct property for your product's name (e.g., name or title) -->
                  {{ product.name }}
                </a>
              </div>
            </div>
          </li>
 
          <!-- Loading -->
          <li v-if="isLoading" class="list-group-item text-center">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </li>
 
          <!-- Empty -->
          <li
            v-else-if="!filteredProfiles.profiles?.length && !filteredProfiles.companies?.length && !filteredProfiles.portals?.length && !filteredProfiles.reports?.length && !filteredProfiles.products?.length && !filteredProfiles.tags?.length && searchQuery"
            class="list-group-item"
          >
            <div class="d-flex align-items-center gap-3 mx-3">
              <i class="bx bx-search-alt text-primary fs-2"></i>
              <div class="d-flex flex-column">
                <span class="text-muted">No results found</span>
              </div>
            </div>
          </li>
 
        </ul>
      </div>
 
 
</div>

 
 
 
    <!-- Right Section: Icons, Notifications, and User Menu -->
    <div class="home-nav-actions d-flex align-items-center" :class="{ 'flex-grow-1': showSearch }">
      <a class="home-nav-action d-flex align-items-center justify-content-center text-decoration-none text-dark text-xxs fw-500 d-md-flex" :class="{ 'd-none': showSearch }" v-if="!isHomePage "
        :href="vettedsa_domain ? '/marketplace' : '/home'">
      <i class="bi bi-house-door-fill fs-2 text-dark"></i>
    </a>
 
 
      <input
        v-model="searchQuery"
        type="text"
        class="form-control p-1 mx-1 text-dark rounded-5 shadow-sm text-xs"
        style="min-width: 0;"
        v-if="showSearch"
        placeholder="Search..."
        @click="show_recent"
        @keydown.enter.prevent="go_to_unified_search"
      />
      <button
        v-if="showSearch"
        type="button"
        class="btn btn-sm border-0 d-flex align-items-center justify-content-center"
        aria-label="Clear search"
        @click.stop="clear_search_dropdown"
      >
        <i class="bi bi-x-lg home-nav-search-x"></i>
      </button>
      <a v-if="token_exists" class="home-nav-action align-items-center justify-content-center text-decoration-none text-dark text-xxs fw-500 d-none d-md-flex" :class="{ 'd-none': showSearch }" @click="toggleMenu">
        <i class="bi bi-grid-fill fs-3"></i>
        </a>

      <!-- Mobile Search Icon -->
      <div v-if="token_exists" class="home-nav-action d-flex d-lg-none align-items-center justify-content-center position-relative" :class="{ 'd-none': showSearch }">
        <i class="bx bx-search-alt-2 fs-1 fw-bold mt-1"   @click="toggleSearch"></i>

      </div>
 
 
    <!-- Menu Icon Button -->
  
      <!-- Dropdown inside navbar -->
      <div v-if="showMenu" class="menu-dropdown ms-0 me-5 mt-1 shadow">
        <MenuSideBar />
      </div>
      <div v-if="client_features.show_marketplace" class="home-nav-action d-flex align-items-center justify-content-center" :class="{ 'd-none': showSearch }">
      <Cart ref="cartRef"/>
      </div>

      <div class="home-nav-action d-none d-xl-flex" :class="{ 'd-none': showSearch }">
        <NotificationDropdown />
      </div>

      <!-- User Menu -->
      <ul class="home-nav-action navbar-nav d-flex flex-row justify-content-center text-xxs fw-500"
        :class="{ 'd-none': showSearch }"
        v-if="token_exists">
        <li class="nav-item" >
          <a class="nav-link d-flex align-items-center justify-content-center" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
            <div v-if="base_profiles.find(profile => profile.is_active)?.profile_files.length"
              class="profile-list-avatar pointer">
            <img
              :src="base_profiles.find(profile => profile.is_active).profile_files[0].file.file_url"
              alt="Profile Image"
              class="d-block rounded profile-image pointer">
          </div>
          <div v-else class="me-2 ms-1 d-flex align-items-center justify-content-center ">
            <i class="bi bi-person-circle fs-2 text-dark pointer">
              
            </i>
          </div>
          </a>
 
       <div class="offcanvas offcanvas-end home-nav-offcanvas" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header home-nav-offcanvas-header">
    <h6 class="dropdown-header text-muted p-0 m-0" id="offcanvasExampleLabel">Main Profiles</h6>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">

    <!-- Personal Profiles -->
    <div v-if="visibleBaseProfiles.some(profile => profile.profile_type === typeOfProfileId('personal'))">
      <div
        v-for="base_profile in visibleBaseProfiles.filter(profile => profile.profile_type === typeOfProfileId('personal'))"
        :key="base_profile.id"
      >
        <a href="#" @click.prevent="control_switching_profile(base_profile); closeHomeNavOffcanvas()"
           class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
          <div class="profile-list-avatar">
            <div v-if="base_profile.profile_files.length">
              <img v-for="file in base_profile.profile_files" :key="file.id" :src="file.file.file_url"
                   class="profile-image rounded" alt="Profile Picture">
            </div>
            <div v-else class="rounded-circle text-white d-flex align-items-center justify-content-center">
              <img src="@/assets/images/user.png" class="w-50" alt="User Icon">
            </div>
          </div>
          <span class="text-xxs">{{ base_profile.profile_name || user_details.first_name }}</span>
          <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
        </a>
      </div>
    </div>

    <!-- Business Profiles -->
    <div v-if="visibleBaseProfiles.some(profile => profile.profile_type === typeOfProfileId('business')) && client_features.show_business_profile">
      <h6 class="dropdown-header text-muted mt-3">Business Profiles</h6>
      <div
        v-for="base_profile in visibleBaseProfiles.filter(profile => profile.profile_type === typeOfProfileId('business'))"
        :key="base_profile.id"
      >
        <a href="#" @click.prevent="control_switching_profile(base_profile); closeHomeNavOffcanvas()"
           class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
          <div class="profile-list-avatar">
            <div v-if="base_profile.profile_files.length">
              <img v-for="file in base_profile.profile_files" :key="file.id" :src="file.file.file_url"
                   class="profile-image rounded" alt="Profile Picture">
            </div>
            <div v-else class="rounded-circle text-white d-flex align-items-center justify-content-center">
              <img src="@/assets/images/user.png" class="w-50" alt="User Icon">
            </div>
          </div>
          <span class="text-xxs">{{ base_profile.profile_name || user_details.first_name }}</span>
          <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
        </a>
      </div>
    </div>

    <!-- Sponsored Ads -->
    <a class="dropdown-item d-flex align-items-center d-none" href="/adverts">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <img src="@/assets/images/advertisement.png" class="w-20px" alt="">
      </div>
      <span class="fw-bold text-xxs">Sponsored Ads</span>
    </a>

    <!-- User Settings Header -->
    <div class="px-3 py-2">
      <h6 class="fw-bold text-xxs text-muted">User Settings</h6>
    </div>

    <!-- Create Business Profile -->
    <div v-if="visible_domain || cbo_domain">
      <button class="dropdown-item d-flex align-items-center" @click="openCompanyProfileModal">
        <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
          <i class="bi bi-briefcase"></i>
        </div>
        <span class="fw-bold text-xxs">Create Business Profile</span>
      </button>

      <button v-if="visibleBaseProfiles.some(profile => profile.profile_type === typeOfProfileId('business'))"
              class="dropdown-item d-flex align-items-center"
              @click="openManageBusiness">
        <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
          <i class="bx bx-cog"></i>
        </div>
        <span class="fw-bold text-xxs">Manage Business</span>
      </button>

      <button
        class="dropdown-item d-flex align-items-center"
        @click="$router.push('/my_orders'); closeHomeNavOffcanvas()"
      >
        <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
          <i class="bi bi-bag-check"></i>
        </div>
        <span class="fw-bold text-xxs">My Orders/Requests</span>
      </button>
    </div>

    <!-- Notifications -->
    <button class="dropdown-item d-flex align-items-center justify-content-between"
            data-bs-toggle="modal"
            data-bs-target="#notificationSettingsModal">
      <div class="d-flex align-items-center">
        <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
          <i class="bx bx-bell"></i>
        </div>
        <span class="fw-bold text-xxs">Manage Notifications</span>
      </div>
    </button>

    <!-- Deactivate Account -->
    <button class="dropdown-item d-flex align-items-center" @click="confirmDeactivation(); closeHomeNavOffcanvas()">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <i class="bx bx-user-x"></i>
      </div>
      <span class="fw-bold text-xxs">Deactivate Account</span>
    </button>

    <!-- Delete Account -->
    <button class="dropdown-item d-flex align-items-center text-danger" @click="confirm_account_deletion(); closeHomeNavOffcanvas()">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <i class="bx bx-trash"></i>
      </div>
      <span class="fw-bold text-xxs">Delete Account</span>
    </button>

    <!-- Logout -->
    <button class="dropdown-item d-flex align-items-center" @click="logout_user(); closeHomeNavOffcanvas()">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <i class="bx bx-log-out"></i>
      </div>
      <span class="fw-bold text-xxs">Log Out</span>
    </button>

  </div>
</div>
        </li>
 
        <li class="nav-item no-arrow mt-1 d-none">
          <!-- Profile Avatar Trigger with Notification Badge -->
          <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="messages_dropdown"
            role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div v-if="base_profiles.find(profile => profile.is_active)?.profile_files.length"
              class="me-2 profile-list-avatar">
            <img
              :src="base_profiles.find(profile => profile.is_active).profile_files[0].file.file_url"
              alt="Profile Image"
              class="d-block rounded profile-image pointer">
          </div>
            <div v-else class="me-2 d-flex align-items-center justify-content-center  mb-1">
              <i class="bi bi-person-circle fs-2 text-dark pointer">
                
              </i>
            </div>
          </a>
 
          <!-- Extended Dropdown Menu -->
          <div class="dropdown-menu dropdown-menu-end shadow border-0 p-0 profile-dropdown-menu">
 
            <!-- User Profile Section -->
            <div class="p-3 border-bottom">
              <!-- -->
 
              <div class="mb-2">
                <!-- Personal Profiles -->
                <h6 class="dropdown-header text-muted">Main Profiles</h6>
                <div
                  v-for="base_profile in visibleBaseProfiles.filter(profile => profile.profile_type ===typeOfProfileId('personal'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="control_switching_profile(base_profile)"
                    class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
                     <div class="profile-list-avatar">
 
                      <!-- Loop through profile_files and show all images -->
                      <div v-if="base_profile.profile_files.length">
                        <img v-for="file in base_profile.profile_files"
                            :key="file.id"
                            :src="file.file.file_url"
                            class="profile-image rounded"
                            alt="Profile Picture">
                      </div>
                      <div v-else class="me-2 ms-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-person-circle fs-3 text-dark pointer">

                        </i>
                      </div>
                    </div>
                    <span class="text-xxs mb-2">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>
 
                <!-- Business Profiles -->
                <h6 v-if="(visible_domain || cbo_domain) && visibleBaseProfiles.filter(profile => profile.profile_type === typeOfProfileId('business')).length >0 " class="dropdown-header text-muted mt-3">Business Profiles</h6>
 
                <div v-if="visible_domain || cbo_domain "
                  v-for="base_profile in visibleBaseProfiles.filter(profile => profile.profile_type === typeOfProfileId('business'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="control_switching_profile(base_profile)"
                    class="d-flex align-items-center gap-3 text-decoration-none text-dark p-2 rounded hover-bg-light">
                    <div class="profile-list-avatar">
                      <!-- Loop through profile_files and show all images -->
                      <div v-if="base_profile.profile_files.length">
                        <img v-for="file in base_profile.profile_files"
                            :key="file.id"
                            :src="file.file.file_url"
                            class="profile-image rounded"
                            alt="Profile Picture">
                      </div>
                      <div v-else class="me-2 ms-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-person-circle fs-3 text-dark pointer">
                        </i>
                    </div>
                  </div>
                    <span class="text-xxs mb-2">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>
 
 
              </div>
            </div>
<div class="">
  <!-- Header -->
  <div class="px-3 py-2 ">
    <h6 class="fw-bold text-xxs text-muted">User Settings</h6>
  </div>

  <div  v-if="visible_domain || cbo_domain">

  <!-- Create Business Profile -->
  <button
    v-if="visible_domain || cbo_domain"
    class="dropdown-item d-flex align-items-center"
    @click="openCompanyProfileModal"

  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bi bi-briefcase"></i>
    </div>
    <span class="fw-bold text-xxs">Create Business Profile</span>
  </button>
 
  <!-- Manage Business -->
  <button
    v-if="visibleBaseProfiles.some(profile => profile.profile_type === typeOfProfileId('business'))"
    class="dropdown-item d-flex align-items-center"
    @click="openManageBusinessModal"
  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bx bx-cog"></i>
    </div>
    <span class="fw-bold text-xxs">Manage Business</span>
  </button>

  <button
    class="dropdown-item d-flex align-items-center"
    @click="$router.push('/my_orders')"
  >
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bi bi-bag-check"></i>
    </div>
    <span class="fw-bold text-xxs">My Orders/Requests</span>
  </button>

  </div>

  <!-- Notifications Toggle Button -->
 <button
    class="dropdown-item d-flex align-items-center justify-content-between"
    data-bs-toggle="modal"
    data-bs-target="#notificationSettingsModal"
  >
    <div class="d-flex align-items-center">
      <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
        <i class="bx bx-bell"></i>
      </div>
      <span class="fw-bold text-xxs"> Manage Notifications</span>
    </div>
  </button>
 
  <!-- Deactivate Account -->
  <button
  class="dropdown-item d-flex align-items-center"
  @click="confirmDeactivation"
  >
  <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
    <i class="bx bx-user-x"></i>
  </div>
  <span class="fw-bold text-xxs">Deactivate Account</span>
</button>

  <!-- Delete Account -->
  <button
  class="dropdown-item d-flex align-items-center text-danger"
  @click="confirm_account_deletion"
  >
  <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
    <i class="bx bx-trash"></i>
  </div>
  <span class="fw-bold text-xxs">Delete Account</span>
</button>
 
  <!-- Logout -->
  <button class="dropdown-item d-flex align-items-center" @click="logout_user">
    <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
      <i class="bx bx-log-out"></i>
    </div>
    <span class="fw-bold text-xxs">Log Out</span>
  </button>
</div>
 
 
 
 
          </div>
        </li>
      </ul>
 
 
 
      <!-- Auth Links (If No Token) -->



  <ul
  :class="[
      'navbar-nav d-flex flex-row justify-content-center w-100',
      token_exists ? 'd-none' : ''
    ]"
>
  <li class="nav-item me-2">
    <router-link
      v-if="!workbook_domain"
      class="btn btn-primary btn-sm text-white shadow-sm rounded nav-link"
      to="sign_up_finale"
    >
      Sign up
    </router-link>
  </li>
  <li class="nav-item">
    <a
      class="btn btn-primary btn-sm text-white shadow-sm rounded nav-link"
      href="/sign_in_Finale"
    >
      Login
    </a>
  </li>
</ul>

    </div>
  </div>
  <!-- Manage Business Modal -->
<div class="modal fade" id="manageBusinessModal" tabindex="-1" aria-labelledby="manageBusinessModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-xxs">
      <div class="modal-header">
        <h5 class="modal-title" id="manageBusinessModalLabel">Manage Business Profiles</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <ul class="list-group">
          <li v-for="profile in visibleBaseProfiles.filter(profile => profile.profile_type === typeOfProfileId('business'))"
              :key="profile.id"
              class="list-group-item d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-2">
              <img v-if="profile.profile_image" :src="profile.profile_image" class="rounded-circle" style="width: 30px; height: 30px;" />
              <div v-else class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                   style="width: 30px; height: 30px;">
                   {{ (profile.profile_name && profile.profile_name.charAt(0)) || (user_details.first_name && user_details.first_name.charAt(0)) }}
                  </div>
              <span>{{ profile.profile_name || user_details.first_name }}</span>
            </div>
            <i class="bx bx-trash text-danger cursor-pointer"
               title="Delete profile"
               @click.prevent="delete_company_profile(profile.id)">
            </i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
 

<!-- Notification Settings Modal -->
<div
  class="modal fade"
  id="notificationSettingsModal"
  tabindex="-1"
  aria-labelledby="notificationSettingsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow">
 
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title fw-bold text-sm" id="notificationSettingsModalLabel">
          Notification Settings
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
 
      <!-- Modal Body -->
      <div class="modal-body">
        <p class="text-muted small mb-3">
          Control how you receive updates and alerts from the platform.
        </p>
 
        <!-- Email Notifications -->
        <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
          <div>
            <h6 class="mb-1">Email Notifications</h6>
            <small class="text-muted">Receive important updates via email.</small>
          </div>
          <div class="form-check ">
            <input
              class="form-check-input"
              type="checkbox"
              id="emailNotificationToggle"
              v-model="receive_emails"
            />
          </div>
        </div>
 
        <!-- In-App Notifications -->
        <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
          <div>
            <h6 class="mb-1">In-App Notifications</h6>
            <small class="text-muted">Get notifications directly inside the app.</small>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="inAppNotificationToggle"
              v-model="receive_notifications"
            />
          </div>
        </div>
      </div>
 
      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary btn-sm text-xxs"
          @click="update_user_settings"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
 
 
 
 
  <!-- Second Row: Mobile Search Input -->
<div v-if="showSearch" class="container-fluid home-nav-mobile-search-results">
  <!-- <input v-model="searchQuery" type="text" class="form-control p-1 mb-3 text-dark rounded shadow" placeholder="Search..." @click="show_recent"/> -->
 
  <div v-if="filteredProfiles"
       class="position-absolute top-100 start-0 end-0 p-0 bg-white shadow rounded-bottom overflow-auto z-3 col-sm ">
    <ul class="list-group">
 
      <!-- Recent Searches -->
      <li v-if="filteredRecent.length>0" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Recent Searches</small>
      </li>
      <li v-if="filteredRecent.length>0"
          v-for="history in filteredRecent"
          :key="`history-${history.id}`"
          class="list-group-item d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <i class="bx bx-history text-secondary"></i>
          <a @click="applyHistory(history.query)" class="text-decoration-none text-dark">
            {{ history.query }}
          </a>
        </div>
        <button class="btn btn-sm btn-light text-danger border-0" @click.stop="removeHistory(history.id)">
          <i class="bx bx-x"></i>
        </button>
      </li>
 
      <!-- People -->
      <li v-if="filteredProfiles.profiles?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">People</small>
      </li>
      <li v-for="profile in filteredProfiles.profiles" :key="`profile-${profile.id}`" class="list-group-item">
        <div @click="view_profile(profile)" class="d-flex align-items-center gap-3 mx-3 pointer">
          <div class="profile-avatar">
            <i class='bx bxs-user-circle text-secondary fs-2'></i>
          </div>
          <div class="d-flex flex-column">
            <a class="text-decoration-none text-dark">
              {{ profile.user.first_name }} {{ profile.user.last_name }}
            </a>
            <small class="text-muted">{{ profile?.user.email || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Companies -->
      <li v-if="filteredProfiles.companies?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Businesses</small>
      </li>
      <li v-for="company in filteredProfiles.companies" :key="`company-${company.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class='bx bxs-briefcase text-secondary fs-2'></i>
          <div class="d-flex flex-column">
            <a @click="view_profile(company)" class="text-decoration-none text-dark">
              {{ company.company_name }}
            </a>
            <small class="text-muted">{{ company?.location || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Portals -->
      <li v-if="filteredProfiles.portals?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Portals</small>
      </li>
      <li v-for="portal in filteredProfiles.portals" :key="`portal-${portal.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class="bx bx-globe text-secondary fs-2"></i>
          <div class="d-flex flex-column">
            <a @click="view_portal(portal)" class="text-decoration-none text-dark">
              {{ portal.portal_name || portal.name }}
            </a>
            <small class="text-muted">{{ portal?.description || '' }}</small>
          </div>
        </div>
      </li>
 
      <!-- Reports -->
      <li v-if="filteredProfiles.reports?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Reports</small>
      </li>
      <li v-for="report in filteredProfiles.reports" :key="`report-${report.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <i class="bx bx-file text-secondary fs-2"></i>
          <div class="d-flex flex-column">
            <a @click="view_report(report)" class="text-decoration-none text-dark">
              <span v-html="displayedDescription(report)"></span>
            </a>
            <small class="text-muted">
              Tags:
              <span v-for="tag in report.tags" :key="tag.id">
                {{ tag.name }}
              </span>
            </small>
          </div>
        </div>
      </li>

      <!-- Products -->
      <li v-if="filteredProfiles.products?.length" class="list-group-item bg-light">
        <small class="text-muted fw-bold">Products</small>
      </li>
      <li v-for="product in filteredProfiles.products" :key="`product-${product.id}`" class="list-group-item">
        <div class="d-flex align-items-center gap-3 mx-3">
          <img
            :src="product.images?.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
            :alt="product.name || 'Product image'"
            class="profile-image rounded profile-list-avatar object-fit-cover flex-shrink-0 mt-2"
          >
          <div class="d-flex flex-column">
            <a class="text-decoration-none text-dark pointer" @click="view_product_details(product)">
              {{ product.name }}
            </a>
          </div>
        </div>
      </li>
 
 
      <!-- Loading -->
      <li v-if="isLoading" class="list-group-item text-center">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </li>
 
      <!-- Empty State -->
      <li v-else-if="!filteredProfiles.profiles?.length &&
                     !filteredProfiles.companies?.length &&
                     !filteredProfiles.portals?.length &&
                     !filteredProfiles.reports?.length &&
                     !filteredProfiles.products?.length &&
                     !filteredProfiles.tags?.length &&
                     searchQuery"
          class="list-group-item text-center">
        <i class="bx bx-search-alt text-primary fs-4 d-block mb-1"></i>
        <span class="text-muted">No results found</span>
      </li>
 
    </ul>
  </div>
</div>
 
</nav>

<div v-if="profile_switch_loading" class="profile-switch-loader-backdrop">
  <div class="profile-switch-loader" role="status" aria-live="polite">
    <div class="profile-switch-loader-icon">
      <i class="bi bi-person-check-fill"></i>
    </div>
    <p class="profile-switch-loader-title">Switching profile</p>
    <p class="profile-switch-loader-text">Getting your workspace ready...</p>
    <div class="profile-switch-loader-dots" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>
  </div>
</div>
 
<!-- <teleport to="body"> -->
  <div class="modal fade" id="company_profile_modal" tabindex="-1" aria-labelledby="company_profile_modallabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
          <p class="modal-title text-xxs text-white" id="company_profile_modallabel">
          {{ is_edit_mode ? 'Edit Business Profile' : 'Create Company Profile' }}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body modal-body-scroll">
          <form @submit.prevent="is_edit_mode ? update_company_profile() : saveCompanyProfile()" id="companyProfileForm" novalidate class="text-xxs">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="company_name" class="form-label fw-500">Company Name<span class="text-danger">
                  *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="company_name" v-model="company_name"
                  placeholder="Company name" :class="{ 'is-invalid': errors.company_name }">
                <p v-if="errors.company_name" class="text-danger text-xxs">{{ errors.company_name }}</p>
              </div>
              <div class="col-md-6">
                 <label for="type_of_organization" class="form-label fw-500">Type of Organization<span class="text-danger">
                  *</span></label>
                <select class="form-control text-xxs rounded" id="type_of_organization"
                  v-model="selected_type_of_organization" :class="{ 'is-invalid': errors.type_of_organization_id }">
                  <option value="">Select Organization Type</option>
                  <option v-for="type in type_of_organization" :key="type.id" :value="type.id">
                    {{ type.type_of_organization.replace('_', ' ').toUpperCase() }}
                  </option>
                </select>
                <p v-if="errors.type_of_organization_id" class="text-danger text-xxs mt-1">{{ errors.type_of_organization_id }}</p>
              </div>
            </div>

            <label for="description" class="form-label fw-500">Description<span class="text-danger"> *</span></label>
            <QuillEditor theme="snow" v-model="description" ref="quillCompanyEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />

              <div class="row mt-3">
                <div class="col-md-6">
                  <label for="email" class="form-label fw-500">Company Email</label>
                  <input type="email" class="form-control text-xxs rounded" id="email" v-model="email"
                    placeholder="Company email" :class="{ 'is-invalid': errors.email }">
                  <p v-if="errors.email" class="text-danger text-xxs">{{ errors.email }}</p>
                </div>
                <div class="col-md-6">
                  <label for="tell_number" class="form-label fw-500">Company Telephone</label>
                  <input type="text" class="form-control text-xxs rounded" id="tell_number" v-model="tell_number"
                    placeholder="Telephone number" :class="{ 'is-invalid': errors.tell_number }">
                  <p v-if="errors.tell_number" class="text-danger text-xxs">{{ errors.tell_number }}</p>
                </div>
                <div class="col-md-12">
                  <label for="mapSearchBox" class="form-label text-xxs fw-500 d-block">Search for Location</label>
                  <input id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                    placeholder="Search location..." v-model="location" :class="{ 'is-invalid': errors.location }"/>
                  <p v-if="errors.location" class="text-danger text-xxs mt-1">{{ errors.location }}</p>
                </div>
                <div class="col-md-6"></div>
              </div>
            <div class="text-end">
              <button type="submit" class="btn btn-primary btn-sm text-white text-xxs shadow-sm rounded mt-2">
              {{ is_edit_mode ? 'Update' : 'Save' }}
            </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
<!-- </teleport> -->
<StickyNav/>
